import image from '../assets/placeholder.svg'

export const DEFAULT_IMG = image

export enum AltType {
  LOCATION = 'location',
}
export const recaptchaSitekey = import.meta.env.VITE_RECAPTCHA_SITEKEY ?? '6LfcbMseAAAAAI-EJoB-lUh7_TJaYloLbcbmnhEO'

export enum LoginStrategy {
  OTP = 'otp',
}

export const DefaultProductImage = 'https://stcdn.leadconnectorhq.com/funnel/store/default-product-image.svg'
